import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'

// route modules
import DeclineMedicareModal from 'components/DeclineMedicareModal/DeclineMedicareModal'
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import person from 'store/modules/persons'
import { isImpersonating } from 'store/modules/user-session/selectors'
import withFeatureFlags from '../../../../../hocs/withFeatureFlags'

const mapStateToProps = (state, { flags }) => {
  return {
    isActivityLogEnabled: flags['enrollme.activity-log-reason-popup-enabled'],
    isTestUser: person.selectors.getPersonSelector(state)?.IsTestUser,
    isImpersonated: isImpersonating(state),
  }
}

const mapDispatchToProps = (dispatch, { data }) => ({
  onCancelClick: () => dispatch(clearModal()),
  onDecline: (props) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      dispatch(clearModal())
      data.declineFn?.(data.person)?.then(() => {
        logGenericActivity({
          additionalData: {
            value: data.person,
            reason,
            reasonCategory,
            zendeskTicket,
            location: window.location.pathname,
          },
          activity: 'declined medical coverage',
          action: ShopForHealthAction.DeclineMedicalCoverage,
        })
      })
    }

    handleActivityLogPopup({
      isImpersonated: props.isImpersonated,
      isTestUser: props.isTestUser,
      isActivityLogEnabled: props.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to decline medical coverage for this member?',
      onSubmit: callback,
    })
  },
})

export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(DeclineMedicareModal))
